export default {"src":"/_next/static/media/fav-tick.6ed9751e.svg","height":11,"width":14};